import { ItemEntity } from '@entities/Item/Types';
import { create } from 'zustand/index';
import {
    emptyPagination,
    PaginationResponse,
} from '@shared/Interfaces/Api/Pagination';

interface ItemsData {
    items: ItemEntity[];
    pagination: PaginationResponse;
}

const emptyItemsData: ItemsData = {
    items: [],
    pagination: emptyPagination,
};

export interface State {
    updatedItems: ItemEntity[];
    itemsData: ItemsData;

    isItemsLoading: boolean;
}

export interface Actions {
    setUpdatedItems: (newUpdatedItems: ItemEntity[]) => void;
    setItemsData: (newItemsData: ItemsData) => void;
    setIsItemsLoading: (isLoading: boolean) => void;
}

export const useItemTypeStore = create<State & Actions>((set, get) => ({
    updatedItems: [],
    itemsData: emptyItemsData,
    isItemsLoading: false,

    setUpdatedItems: (newUpdatedItems: ItemEntity[]) => {
        set({ updatedItems: newUpdatedItems });
    },
    setItemsData: (newItemsData: ItemsData) => {
        set({ itemsData: newItemsData });
    },
    setIsItemsLoading: (isLoading: boolean) => {
        set({ isItemsLoading: isLoading });
    },
}));
